module.exports = __webpack_public_path__ + "static/img/6.ecb50e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/6.png
// module id = lozT
// module chunks = 1